{
  "code": "EX-00",
  "COMPANY_TYPE": "Pharma",
  "LOGO_ICON": "/assets/imgs/logo.png",

  "ABOUT_US__BLOCK_01__COPY": "Una solución de e-Commerce Mobile para la industria farmacéutica.",
  "ABOUT_US__BLOCK_02__TITLE": "Pharma360",
  "ABOUT_US__BLOCK_02__COPY": "Una plataforma de inteligencia de negocios farmacéuticos para la gestión integral de procesos.",
  "ABOUT_US__BLOCK_03__TITLE": "Nosotros",
  "ABOUT_US__BLOCK_03__COPY": "Somos expertos en el desarrollo de soluciones, orientadas a la automatización y gestión integral de procesos."
}
